import React, { useState } from "react";
import "./RequestQuote.css";
import {
  FaCity,
  FaMapMarkerAlt,
  FaBuilding,
  FaClipboardList,
  FaCommentDots,
  FaCubes,
  FaTruck,
  FaShieldAlt,
  FaHandshake,
  FaEnvelope,
  FaPhoneAlt,
} from "react-icons/fa";
import { db, ref, set } from "../Firebase/firebase-config";
import { push } from "firebase/database";
import { FaCheckCircle, FaArrowLeft } from "react-icons/fa";

import "./RequestQuote.css"

import ReCAPTCHA from "react-google-recaptcha";

const cementBrands = [
  "UltraTech",
  "Shree",
  "JK Super",
  "Ambuja",
  "ACC",
  "JSW",
];

const cementGrades = [
  "OPC 43",
  "OPC 53",
  "PPC",
  "PSC",
];


export default function RequestQuote() {
  const [formData, setFormData] = useState({
    city: "",
    area: "",
    brand: "",
    grade: "",
    email: "",
    phone: "",
    quantity: "",
    unit: "Bags",
    requirement: "",
  });

  const [captchaValue, setCaptchaValue] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaValue) {
      alert("Please verify that you're not a robot.");
      return;
    }

    try {
      // Create a new unique node
      const newQuoteRef = push(ref(db, "quoteRequest"));

      await set(newQuoteRef, {
        ...formData,
        createdAt: Date.now(),
        status: "pending",
      });

      setSubmitted(true);

      // setTimeout(() => {
      //   window.history.back();
      // }, 5000);

      setFormData({
        city: "",
        area: "",
        brand: "",
        grade: "",
        email: "",
        phone: "",
        quantity: "",
        unit: "Bags",
        serviceCategory: "",
        requirement: "",
      });

      setCaptchaValue(null);
    } catch (error) {
      console.error(error);
      alert("Something went wrong. Please try again.");
    }
  };
  if (submitted) {
    return (
      <section className="quote-success-wrapper">

        <div className="quote-success-card">

          <div className="success-icon">
            <FaCheckCircle />
          </div>

          <h2>Quote Request Submitted!</h2>

          <p>
            Thank you for your request.
            <br />
            Our team will contact you shortly with the best quotation.
          </p>

          <div className="success-buttons">

            <button
              className="back-btn"
              onClick={() => window.history.back()}
            >
              <FaArrowLeft />
              <span>Go Back</span>
            </button>

            <button
              className="new-request-btn"
              onClick={() => setSubmitted(false)}
            >
              New Request
            </button>

          </div>

        </div>
      </section>
    );
  }
  return (
    <section className="quote-section">

      <div className="quote-card">
        <button
          type="button"
          className="quote-back-btn"
          onClick={() => window.history.back()}
        >
          <FaArrowLeft size={15} />
          <span>Back</span>
        </button>
        <div className="quote-header">

          <span className="quote-badge">
            GET BEST PRICE
          </span>

          <h2>Request Cement Quote</h2>

          <p>
            Compare prices from trusted cement suppliers and
            receive your quotation quickly.
          </p>

        </div>

        <div className="quote-note">
          <strong>* Note: </strong>  We deal only in <strong>non-trade bulk cement orders</strong>.

        </div>
        <form onSubmit={handleSubmit}>

          {/* LOCATION */}

          <div className="quote-grid">

            <div className="quote-input">

              <label>
                <FaCity />
                City <b className="text-danger">*</b>
              </label>

              <input
                type="text"
                name="city"
                placeholder="e.g. Pune"
                value={formData.city}
                onChange={handleChange}
                required
              />

            </div>

            <div className="quote-input">

              <label>
                <FaMapMarkerAlt />
                Area <b className="text-danger">*</b>
              </label>

              <input
                type="text"
                name="area"
                placeholder="e.g. Wakad / Sector 62"
                value={formData.area}
                onChange={handleChange}
                required
              />

            </div>

          </div>
          {/* CONTACT DETAILS */}

          <div className="quote-grid">

            <div className="quote-input">
              <label>
                <FaEnvelope />
                Email Address <b className="text-danger">*</b>
              </label>

              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="quote-input">
              <label>
                <FaPhoneAlt />
                Mobile Number <b className="text-danger">*</b>
              </label>

              <input
                type="tel"
                name="phone"
                placeholder="Enter mobile number"
                value={formData.phone}
                onChange={handleChange}
                maxLength={10}
                pattern="[6-9]{1}[0-9]{9}"
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, "");
                }}
                required
              />
            </div>

          </div>
          {/* BRAND */}

          <div className="quote-grid">

            <div className="quote-input">

              <label>
                <FaBuilding />
                Select Brand <b className="text-danger">*</b>
              </label>

              <select
                name="brand"
                value={formData.brand}
                onChange={handleChange}
                required
              >
                <option value="">
                  Choose Brand
                </option>

                {cementBrands.map((brand) => (
                  <option
                    key={brand}
                    value={brand}
                  >
                    {brand}
                  </option>
                ))}

              </select>

            </div>

            <div className="quote-input">

              <label>
                <FaClipboardList />
                Select Grade <b className="text-danger">*</b>
              </label>

              <select
                name="grade"
                value={formData.grade}
                onChange={handleChange}
                required
              >
                <option value="">
                  Choose Grade <b className="text-danger">*</b>
                </option>

                {cementGrades.map((grade) => (
                  <option
                    key={grade}
                    value={grade}
                  >
                    {grade}
                  </option>
                ))}

              </select>

            </div>

          </div>

          {/* QUANTITY */}

          <div className="quote-grid">

            <div className="quote-input">

              <label>
                <FaCubes />
                Quantity <b className="text-danger">*</b>
              </label>

              <input
                type="number"
                name="quantity"
                placeholder="Enter Quantity"
                value={formData.quantity}
                onChange={handleChange}
                required
                min={1}
              />
            </div>
            <div className="quote-input">
              <label>
                Unit <b className="text-danger">*</b>
              </label>

              <select
                name="unit"
                value={formData.unit}
                onChange={handleChange}
              >
                <option>Bags</option>
                <option>MT</option>
              </select>
            </div>
          </div>

          {/* REQUIREMENT */}

          <div className="quote-input">
            <label>
              <FaCommentDots />
              Requirement (Optional)
            </label>

            <textarea
              rows={2}
              name="requirement"
              maxLength={200}
              placeholder="Example: Need 500 Bags of UltraTech OPC 53 for residential project. Delivery required within 2 days."
              value={formData.requirement}
              onChange={handleChange}
            />

            <small className="text-counter">
              {formData.requirement.length}/200 characters
            </small>
          </div>


          {/* CAPTCHA */}

          <div className="captcha-box">

            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              onChange={(value) => setCaptchaValue(value)}
            />

          </div>

          {/* SUBMIT */}

          <button
            type="submit"
            className="quote-submit-btn"
          >
            Request Best Quote
          </button>

        </form>

      </div>
      <div className="quote-trust">

        <div className="trust-item">
          <FaTruck />
          <h4>Fast Delivery</h4>
          <p>Delivery across India</p>
        </div>

        <div className="trust-item">
          <FaShieldAlt />
          <h4>Trusted Suppliers</h4>
          <p>Verified Cement Dealers</p>
        </div>

        <div className="trust-item">
          <FaHandshake />
          <h4>Best Prices</h4>
          <p>Competitive market quotations</p>
        </div>

      </div>
    </section>

  );
}